import React from "react";
import { CircularProgress } from "@material-ui/core";
import { STGrid } from "./styles";

export default class AppPreloader extends React.Component {
  render() {
    return (
      <STGrid
        container
        justify="center"
        alignItems="center"
        alignContent="center"
      >
        <CircularProgress />
      </STGrid>
    );
  }
}
